module.exports = __webpack_public_path__ + "static/media/29DUNON9.fc9ad3f4.jpg";